import { KleanadsScopeConfig, PbjsDesiredVersion } from '@pubstack/common/src/kleanadsScopeConfig'
import { AdmSiteConfig } from '@pubstack/common/src/siteConfig'
import { MutationToasts, useMutation, useQuery } from '../api-client'

export const KLEANADS_SCOPE_CONFIG_QUERY_KEYS = ['admin', 'kleanads-scope-config']
export const KLEANADS_SITE_CONFIG_QUERY_KEYS = ['admin', 'kleanads-site-config']

//-------------------------------------------------------------------------
// Site Config Queries
//-------------------------------------------------------------------------

export const useKleanadsSiteConfig = (scopeId: string, siteId?: string) => {
  return useQuery<AdmSiteConfig>({
    url: `/admin/scopes/${scopeId}/site-config/${siteId}`,
    keys: [...KLEANADS_SITE_CONFIG_QUERY_KEYS, scopeId, siteId ?? ''],
    enabled: !!siteId,
  })
}

//-------------------------------------------------------------------------
// Site Config Mutations
//-------------------------------------------------------------------------

export const useUpdateKleanadsSiteConfig = (scopeId: string, siteId?: string, toasts: MutationToasts = {}) => {
  return useMutation<AdmSiteConfig, AdmSiteConfig>({
    method: 'put',
    url: `/admin/scopes/${scopeId}/site-config/${siteId}`,
    collectionKeys: [...KLEANADS_SITE_CONFIG_QUERY_KEYS, scopeId],
    ...toasts,
  })
}

//-------------------------------------------------------------------------
// Scope Config Queries
//-------------------------------------------------------------------------

export const useKleanadsScopeConfig = (scopeId: string) => {
  return useQuery<KleanadsScopeConfig>({
    url: `/admin/scopes/${scopeId}/adm-scope-config`,
    keys: [...KLEANADS_SCOPE_CONFIG_QUERY_KEYS, scopeId],
  })
}

export const useKleanadsScopeConfigFind = (scopeId: string) => {
  return useQuery<KleanadsScopeConfig>({
    url: `/admin/scopes/${scopeId}/adm-scope-config/find`,
    keys: [...KLEANADS_SCOPE_CONFIG_QUERY_KEYS, scopeId, 'find'],
  })
}

//-------------------------------------------------------------------------
// Scope Config Mutations
//-------------------------------------------------------------------------

export const useCreateKleanadsScopeConfig = (scopeId: string, toasts: MutationToasts = {}) => {
  return useMutation<KleanadsScopeConfig, KleanadsScopeConfig>({
    method: 'post',
    url: `/admin/scopes/${scopeId}/adm-scope-config`,
    collectionKeys: [...KLEANADS_SCOPE_CONFIG_QUERY_KEYS, scopeId],
    ...toasts,
  })
}

export const useUpdateKleanadsPbjsDesired = (scopeId: string, toasts: MutationToasts = {}) => {
  return useMutation<PbjsDesiredVersion, KleanadsScopeConfig>({
    method: 'put',
    url: `/admin/scopes/${scopeId}/adm-scope-config/pbjs-desired`,
    collectionKeys: [...KLEANADS_SCOPE_CONFIG_QUERY_KEYS, scopeId],
    ...toasts,
  })
}

export const useUpdateKleanadsPocOverrides = (scopeId: string, toasts: MutationToasts = {}) => {
  return useMutation<KleanadsScopeConfig['pocOverrides'], KleanadsScopeConfig['pocOverrides']>({
    method: 'put',
    url: `/admin/scopes/${scopeId}/adm-scope-config/poc-overrides`,
    collectionKeys: [...KLEANADS_SCOPE_CONFIG_QUERY_KEYS, scopeId],
    ...toasts,
  })
}

export const useUpdateKleanadsS2SConfig = (scopeId: string, toasts: MutationToasts = {}) => {
  return useMutation<KleanadsScopeConfig['pbjsConfig']['s2sConfig'], KleanadsScopeConfig>({
    method: 'put',
    url: `/admin/scopes/${scopeId}/adm-scope-config/s2s-config`,
    collectionKeys: [...KLEANADS_SCOPE_CONFIG_QUERY_KEYS, scopeId],
    ...toasts,
  })
}
